export const WHITE_LABEL_KEY = 'shipt'
export const WHITE_LABEL_DOMAIN = 'shipt.com'
